import React, { useState, useEffect, useMemo } from "react"
import { ThemeProvider } from "styled-components"
import uniq from "lodash.uniq"

import sortBy from "utils/sortBy"
import componentThemeExtension from "utils/componentThemeExtension"

import { Container, Box, Title, Select } from "./styles"

const FilterSort = ({ allVideos, setFilteredVideos }) => {
  const [selectedYear, setSelectedYear] = useState("all")
  const yearOptions = useMemo(
    () =>
      uniq(
        allVideos
          .map((video) => new Date(video.airDate).getFullYear())
          .sort()
          .reverse(),
      ),
    [allVideos],
  )

  const [selectedTopic, setSelectedTopic] = useState("all")
  const topicOptions = {
    food: "Food",
    health: "Health",
    mindfulness: "Mindfulness",
    movement: "Movement",
    planet: "Planet",
    relationships: "Relationships",
  }

  const [selectedSort, setSelectedSort] = useState("Newest")
  const sortOptions = ["A-Z", "Z-A", "Newest", "Oldest", "Longest", "Shortest"]

  useEffect(() => {
    let videos
    if (selectedYear === "all" && selectedTopic === "all") {
      videos = allVideos
    } else if (selectedTopic === "all") {
      videos = allVideos.filter(
        (video) => new Date(video.airDate).getFullYear().toString() === selectedYear,
      )
    } else if (selectedYear === "all") {
      videos = allVideos.filter((video) => video.tags?.includes(selectedTopic))
    } else {
      videos = allVideos.filter(
        (video) =>
          new Date(video.airDate).getFullYear().toString() === selectedYear &&
          video.tags?.includes(selectedTopic),
      )
    }

    switch (selectedSort) {
      case "A-Z":
        videos = sortBy(videos, "title")
        break
      case "Z-A":
        videos = sortBy(videos, "title").reverse()
        break
      case "Newest":
        videos = sortBy(videos, "airDate").reverse()
        break
      case "Oldest":
        videos = sortBy(videos, "airDate")
        break
      case "Longest":
        videos = sortBy(videos, ({ lengthInSeconds }) => lengthInSeconds || 0).reverse()
        break
      case "Shortest":
        videos = sortBy(videos, ({ lengthInSeconds }) => lengthInSeconds || 0)
        break
      default:
        break
    }

    setFilteredVideos(videos)
  }, [allVideos, setFilteredVideos, selectedYear, selectedTopic, selectedSort])

  return (
    <ThemeProvider theme={componentThemeExtension("Light Background Primary")}>
      <Container>
        <Box>
          <Title>Filter by</Title>
          <Select
            name="filterByYear"
            items={[
              { value: "all", label: "All Years" },
              ...yearOptions.map((year) => ({ value: year, label: year })),
            ]}
            onChange={setSelectedYear}
          />
          <Select
            name="filterByTopic"
            items={[
              { value: "all", label: "All Topics" },
              ...Object.entries(topicOptions).map(([value, label]) => ({ value, label })),
            ]}
            onChange={setSelectedTopic}
          />
        </Box>
        <Box>
          <Title>Sort by</Title>
          <Select
            name="sortBy"
            items={sortOptions.map((sort) => ({ value: sort, label: sort }))}
            initialValue="Newest"
            onChange={setSelectedSort}
          />
        </Box>
      </Container>
    </ThemeProvider>
  )
}

export default FilterSort
